module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABmwAAAZsBqMTCdgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAA/SURBVEiJ7c6xCQAgEENRz/33EkFcKXYiV9iYwuK/AX5SCgD8QdKUzzjbkYbkPB4Ru1+d4Zs81I3tZmwBwIsF9hFU4pXW3cMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/subtract.png
// module id = 207
// module chunks = 0